<template>
  <SignUp />
</template>

<script>
import SignUp from "../../components/Sign/SignUp.vue";
export default {
  name: "SignUpPage",
  components: {
    SignUp,
  },
};
</script>

<style>
</style>